export default __webpack_public_path__ + "static/media/unavailable.52c6713d.png";